import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { type IconButtonProps } from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import DeleteIconButton from "_shared/_views/buttons/delete-icon-button";

/**
 * The neutral-until-hovered delete button, at the density the proposal panes need.
 *
 * The colour lives in `DeleteIconButton` and is shared with every other inline trash in the app.
 * What is proposal-specific is the padding: these sit in redline rows, reviewer chips and team
 * lists inside a pane that is already competing for width, so they run tighter than a default
 * `IconButton` — and they always carry the same outlined glyph, which is why this one takes no
 * children where the shared button does.
 */
const DeleteActionButton = styled(DeleteIconButton)(({ theme }) => ({
  padding: theme.spacing(0.5),
}));

export default function ProposalDeleteActionButton(props: Readonly<IconButtonProps>) {
  return (
    <DeleteActionButton {...props}>
      <DeleteOutlinedIcon />
    </DeleteActionButton>
  );
}
